import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, MenuItem, Select, FormControl, Paper, Typography, TextField } from "@material-ui/core";
import MainContainer from "../../../components/MainContainer";
import { userDetailContext } from "../../../App";
import { useNavigate } from 'react-router-dom';
import { headerDataRH } from "../../../data/modules/hr-header";
import Button from '@mui/material/Button';
import FilterListIcon from '@mui/icons-material/FilterList';
import UserService from "../../../services/UserService";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { DataGrid } from "@material-ui/data-grid";
import LeaveService from "../../../services/LeaveService";
import { DownloadOutlined } from "@mui/icons-material";

// Styles
const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 0,
  },
}));

export default function Rapporthistory(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const contextData = useContext(userDetailContext);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const [rows,setRows]=useState([]);

  const [year, setYear] = useState(currentYear);
  const [direction, setDirection] = useState([]);
  const [valdir, setValdir] = useState(null); 

  const getYearRange = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2024;
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };

  const years = getYearRange();

  // Gestion du changement d'année
  const handleChangeyear = (ev) => {
    const yearSelected = ev.target.value;
    setYear(yearSelected);
  };

  // Gestion du changement de direction
  const handleChangeDirdestination = (event, value) => {
    setValdir(value);
    if (value) {
      const iddir = value.direction_id;
      // setFilter({ ...filter, directiondest: iddir }); // Mettre à jour le filtre si nécessaire
    }
  };

  const downloadFile = (filename, fileType) => {
    const url = `https://pgi.fid.mg/pgibackend/uploads/Rapportmensuelconge/${filename}`;

    const link = document.createElement('a');
    link.href = url;
    link.download = filename; 

    fetch(url, { method: 'HEAD' })
        .then((response) => {
            if (response.ok) {
                link.click();
            } else {
                alert('Le fichier est introuvable ou il y a un problème avec l\'URL.');
            }
        })
        .catch((error) => {
            alert('Erreur lors du téléchargement du fichier.');
        });
};


  const column = [
    {
        field: 'annee',
        headerName: 'Année',
        width: 150,
    },
    {
        field: 'mois',
        headerName: 'Mois',
        width: 150,
    },
    {
        field: 'name',
        headerName: 'Nom et Prénoms',
        width: 300,
    },
    {
      field: 'filename',
      headerName: 'Version Excel',
      width: 250,
      renderCell: (params) => (
          <Button
              icon={<DownloadOutlined />}
              onClick={() => downloadFile(params.value, 'excel')}
          >
              <DownloadOutlined style={{ color: "#1a5fa1" }} />
              Télécharger Excel
          </Button>
      ),
      },
      {
        field: 'filenamepdf',
        headerName: 'Version PDF',
        width: 250,
        renderCell: (params) => (
            <Button
                icon={<DownloadOutlined />}
                onClick={() => downloadFile(params.value, 'pdf')}
            >
               <DownloadOutlined style={{ color: "#1a5fa1" }} />
                Télécharger PDF
            </Button>
        ),
      },
      {
        field: 'created_at',
        headerName: 'Date de création',
         width: 200,
      }
];


function loadTable(valdir, year) {
  
  LeaveService.historymansuel(year, valdir.direction_id)
    .then((result) => {
      if (result && result.data) {
        setRows(result.data); 
      } else {
        setRows([]);  
      }
    })
    .catch((error) => {
      setRows([]);  
    });
}

  useEffect(() => {
    const userData = localStorage.getItem('USER');
    if (userData) {
      UserService.getUserSummaryByUserId(userData)
        .then((result) => {
          if (result && result.data) {
            const dirpers = result.data.direction_id;

            PlanningMissionService.getDirection().then((result) => {
              if (result && result.data) {
                if (parseInt(dirpers, 10) === 1) {
                  setDirection(result.data);
                } else {
                  setDirection(result.data.filter(ts => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)));
                }
                const filteredDirections = result.data.filter(
                  (ts) => parseInt(ts.direction_id, 10) === parseInt(dirpers, 10)
                );
                setValdir(filteredDirections[0] || null);
                loadTable(filteredDirections[0],year);
              }
            }).catch((error) => {
              console.error('Error fetching direction data:', error);
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching user summary:', error);
        });
    }
 
  }, []);

  return (
    <MainContainer {...headerDataRH}>
      <Typography style={{ textAlign: "center", width: "100%", display: "block" }} component="h2" variant="h6" color="primary" gutterBottom>
        Historique de la génération du rapport mensuel
      </Typography>
      <Paper className={classes.paper} variant="outlined">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={year}
                    name="year"
                    onChange={handleChangeyear}
                  >
                    {years.map((year, index) => (
                      <MenuItem key={index} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  onChange={handleChangeDirdestination}
                  value={valdir}
                  name="direction"
                  options={direction}
                  getOptionLabel={(option) => option ? `${option.name} (${option.code})` : ''}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                      InputProps={{ ...params.InputProps, type: 'search' }}
                      placeholder={valdir ? `${valdir.name} (${valdir.code})` : 'Sélectionnez une direction'}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<FilterListIcon />}
                  onClick={() => {
                    loadTable(valdir,year)
                  }}
                >
                  Filtrer
                </Button>
              </Grid>
              <Grid item xs={12}>
                    <div style={{ height: "70vh", width: "100%" }}>
                        <DataGrid
                            columns={column}
                            rows={rows}
                            pageSize={7}
                            rowsPerPageOptions={[7]}
                            disableSelectionOnClick
                        />
                    </div>
                </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </MainContainer>
  );
}